import { MDCRipple } from '@material/ripple';
import { MDCTopAppBar } from '@material/top-app-bar';
import { MDCTextField } from '@material/textfield';
import { MDCDrawer } from "@material/drawer";
import { MDCFormField } from '@material/form-field';
import { MDCRadio } from '@material/radio';
import { MDCTooltip } from '@material/tooltip';

import { MDCTabBar } from '@material/tab-bar';
import { MDCDataTable } from '@material/data-table';

new MDCDataTable(document.querySelector('.mdc-data-table'));

new MDCTabBar(document.querySelector('.mdc-tab-bar'));
Array.from(document.querySelectorAll('.mdc-tab')).forEach(
	tab => tab.addEventListener('MDCTab:interacted', (e) => switchToTab(e.detail.tabId))
);
const switchToTab = (activatedTabId) => {
	Array.from(document.querySelectorAll('.tab-content')).forEach(tabContent => {
		tabContent.style.display = tabContent.id.slice(0, -1 * '-content'.length) == activatedTabId.slice(0, -1 * '-tab'.length) ? 'block' : 'none';
	});
}

const toolTips = Array.from(document.querySelectorAll('.mdc-tooltip'));
toolTips.forEach((el) => {
	const toolTip = new MDCTooltip(el);
	toolTip.setTooltipPosition({ xPos: 1, yPos: 1, withCaretPos: 4 });
});

const formFields = Array.from(document.querySelectorAll('.mdc-form-field'));
formFields.forEach((el) => {
	const radioButton = el.querySelector('.mdc-radio');
	if (radioButton) {
		const formField = new MDCFormField(el);
		formField.input = radioButton;
	}
});

// Instantiation
const topAppBarElement = document.querySelector('.mdc-top-app-bar');
new MDCTopAppBar(topAppBarElement);

new MDCTextField(document.querySelector('.mdc-text-field'));

new MDCRipple(document.querySelector('.mdc-button'));